/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/toggle/toggle.component.ngfactory';
import * as import2 from '../../ui-elements/toggle/toggle.component';
import * as import3 from '@angular/common';
import * as import4 from './selection-field.component';
import * as import5 from '../field/field.component.ngfactory';
import * as import6 from '../field/field.component';
import * as import7 from '../form/form.component';
import * as import8 from '@angular/forms';
import * as import9 from 'ng2-translate/src/translate.pipe';
import * as import10 from 'ng2-translate/src/translate.service';
import * as import11 from '../../orchestration/navigation.service';
const styles_SelectionFieldComponent:any[] = ([] as any[]);
export const RenderType_SelectionFieldComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_SelectionFieldComponent,
  data: {}
}
);
function View_SelectionFieldComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-toggle',[[
        'class',
        'selection-field-toggle'
      ]
    ],(null as any),(null as any),(null as any),import1.View_ToggleComponent_0,import1.RenderType_ToggleComponent)),
      import0.ɵdid(573440,(null as any),0,import2.ToggleComponent,[import0.ChangeDetectorRef],{active: [
        0,
        'active'
      ]
    },(null as any)),
    import0.ɵpid(131072,import3.AsyncPipe,[import0.ChangeDetectorRef])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.toggleActive || import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(import0.ɵnov((<any>v.parent),2).touchable.touched$)));
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_SelectionFieldComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{inputER: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'woa-field',([] as any[]),[[
        2,
        'no-message',
        (null as any)
      ]
    ],[
      [
        (null as any),
        'onActivateField'
      ]
      ,
      [
        (null as any),
        'onActivateLink'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.SelectionFieldComponent = v.component;
      if (('onActivateField' === en)) {
        const pd_0:any = ((<any>co.activated()) !== false);
        ad = (pd_0 && ad);
      }
      if (('onActivateLink' === en)) {
        const pd_1:any = ((<any>co.onActivateLink.emit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import5.View_FieldComponent_0,import5.RenderType_FieldComponent)),
      import0.ɵdid(49152,[[
        'field',
        4
      ]
    ],1,import6.FieldComponent,[
      [
        2,
        import7.FormComponent
      ]
      ,
      [
        2,
        import8.NgControl
      ]

    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      link: [
        1,
        'link'
      ]
      ,
      message: [
        2,
        'message'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]
      ,
      noMessage: [
        4,
        'noMessage'
      ]
      ,
      showMessageSpinner: [
        5,
        'showMessageSpinner'
      ]
      ,
      readOnly: [
        6,
        'readOnly'
      ]
      ,
      disabled: [
        7,
        'disabled'
      ]

    }
    ,{
      onActivateField: 'onActivateField',
      onActivateLink: 'onActivateLink'
    }
    ),
    import0.ɵqud(603979776,2,{models: 1}),
    (l()(),import0.ɵted(0,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),0,2,'div',[[
        'class',
        'selection-field-value'
      ]
      ],[[
        2,
        'empty',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    import0.ɵpid(131072,import9.TranslatePipe,[
      import10.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_SelectionFieldComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.SelectionFieldComponent = v.component;
    const currVal_1:any = co.label;
    const currVal_2:any = co.link;
    const currVal_3:any = co.message;
    const currVal_4:any = co.translationParams;
    const currVal_5:any = co.noMessage;
    const currVal_6:any = co.showMessageSpinner;
    const currVal_7:any = co.readOnly;
    const currVal_8:any = co.disabled;
    ck(v,2,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
    const currVal_11:boolean = (!co.disabled && !co.readOnly);
    ck(v,10,0,currVal_11);
  },(ck,v) => {
    var co:import4.SelectionFieldComponent = v.component;
    const currVal_0:any = import0.ɵnov(v,2).noMessage;
    ck(v,1,0,currVal_0);
    const currVal_9:any = (co.value == (undefined as any));
    ck(v,5,0,currVal_9);
    const currVal_10:any = (co.displayValue || import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform(co.placeholder,co.translationParams)));
    ck(v,6,0,currVal_10);
  });
}
function View_SelectionFieldComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-selection-field',([] as any[]),(null as any),(null as any),(null as any),View_SelectionFieldComponent_0,RenderType_SelectionFieldComponent)),
    import0.ɵdid(180224,(null as any),1,import4.SelectionFieldComponent,[
      import0.ChangeDetectorRef,
      import10.TranslateService,
      import11.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,1,{optionComponents: 1}),
    import0.ɵprd(5120,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import4.SelectionFieldComponent])
  ]
  ,(null as any),(null as any));
}
export const SelectionFieldComponentNgFactory:import0.ComponentFactory<import4.SelectionFieldComponent> = import0.ɵccf('woa-selection-field',import4.SelectionFieldComponent,View_SelectionFieldComponent_Host_0,{
  inputId: 'inputId',
  label: 'label',
  link: 'link',
  placeholder: 'placeholder',
  message: 'message',
  translationParams: 'translationParams',
  readOnly: 'readOnly',
  disabled: 'disabled',
  value: 'value',
  optionsTitle: 'optionsTitle',
  noMessage: 'noMessage',
  showMessageSpinner: 'showMessageSpinner',
  toggleActive: 'toggleActive',
  showNone: 'showNone'
}
,{
  valueChange: 'valueChange',
  onActivateLink: 'onActivateLink',
  onActivateField: 'onActivateField'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/inputs/selection-field/selection-field.component.ngfactory.ts